import { render, staticRenderFns } from "./patientInfo.vue?vue&type=template&id=94701e34&scoped=true&"
import script from "./patientInfo.vue?vue&type=script&lang=js&"
export * from "./patientInfo.vue?vue&type=script&lang=js&"
import style0 from "./patientInfo.vue?vue&type=style&index=0&id=94701e34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94701e34",
  null
  
)

export default component.exports